import { defineMessages } from "@/i18n";
import en from "./en";

export const onboardingGuideMessages = defineMessages("onboarding-guide", en);
